import Tag from 'src/models/Tag';
import DOMPurify from 'dompurify';
 
const tagsToString = (tagItems: Tag[]) => {
    let tempString = '';
    tagItems.forEach((tag, index) => {
        tempString = tempString.concat(tag.name);
        if (tag !== tagItems[tagItems.length - 1]) {
            tempString = tempString.concat(', ');
        }
    });
    return (
        tempString.concat(' ')
    );
};

export const checkScrollStatus = (divElement: HTMLDivElement) => {
    if (divElement) {
        const scrollTop = divElement.scrollTop % 1 > .9 ? divElement.scrollTop : Math.round(divElement.scrollTop);
        const scrollHeight = divElement.scrollHeight;
        const clientHeight = divElement.clientHeight;

        // Check if reached the end of the list
        return (scrollTop + clientHeight >= scrollHeight - 5);
    }
    return false;
};

export const sanitizeHtml = (htmlText: string) => {
    let newText = DOMPurify.sanitize(htmlText, {
        FORBID_TAGS: ['style', 'iframe'],
        FORBID_ATTR: ['onerror']
    });

    return newText;
};

export default tagsToString;


// WEBPACK FOOTER //
// ./src/components/common/UtilityFunctions.tsx